import { apiInstance, apiInstanceUserToken } from '../helpers';
import axios from "axios";

export const validationServices = {
    create,
    createSAE
};

function create(params, validationExistsVialExpiryDate='', validationPatientDiedDate='') {

    if (validationExistsVialExpiryDate !== '') {
        params.validationExistsVialExpiryDate = validationExistsVialExpiryDate;
    }
    if (validationPatientDiedDate !== '') {
        params.validationPatientDiedDate = validationPatientDiedDate;
    }

    return axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
        'Access-Control-Allow-Origin': process.env.REACT_APP_UI_URL,
      }
    }).post('/validation', params)
        .then(response => {
            return response
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


function createSAE(params) {
    return apiInstance().post('/sae_reporting', params)
        .then(response => {
            return response
        })
        .catch(error => {
            return Promise.reject(error);
        });
}




// WEBPACK FOOTER //
// ./src/services/validation.services.js